<template>
  <div
    v-if="currentValue || editionMode"
    class="flex flex-row gap-2"
    :class="[className, $attrs.class]"
  >
    <div class="flex-1">
      <slot name="default" />
    </div>
    <div v-if="editionMode" class="flex shrink-0 flex-row items-center">
      <button
        :data-tint="currentValue ? 'green' : 'red'"
        class="bg-primary text-contrast-primary h-8 w-8 rounded border border-slate-400 dark:bg-slate-500"
        @click="toggleProperty('visible')"
      >
        <FontAwesomeIcon :icon="['fal', currentValue ? 'eye' : 'eye-slash']" />
      </button>

      <button
        v-if="currentValue"
        class="h-8 w-8 rounded border bg-yellow-500 dark:bg-yellow-600"
        @click="toggleProperty('required')"
      >
        <span v-if="currentRequired" class="text-2xl text-red-600">*</span>
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'circle-minus']"
          class="text-sm text-white"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { set, get } from 'lodash-es'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'InputViewerSelector',
  components: { FontAwesomeIcon },
  props: {
    path: {
      type: String,
      required: true
    },
    className: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      editionMode: 'metadata/getGlobalFormEditionMode',
      currentFormSettings: 'metadata/getGlobalFormCurrentFormSettings'
    }),
    viewMode() {
      return this.$route.meta.display_type ?? 'view'
    },
    currentValue() {
      const obj = get(this.currentFormSettings, this.path)

      if (obj && typeof obj === 'object' && 'visible' in obj) {
        return obj.visible
      }
      if (typeof obj === 'boolean') return obj

      return true
    },

    currentRequired() {
      const obj = get(this.currentFormSettings, this.path)

      if (obj && typeof obj === 'object' && 'required' in obj) {
        return obj.required
      }

      return false
    }
  },
  methods: {
    ...mapMutations({
      mutateFormConfig: 'metadata/updateFormConfigSettings'
    }),
    // enable(value) {
    //   let newForm = set(this.currentFormSettings, this.path, value)
    //   this.mutateFormConfig(newForm)
    // }
    toggleProperty(prop) {
      const obj = get(this.currentFormSettings, this.path)
      let newObj

      if (!obj) {
        newObj = { visible: true, required: false }
      } else if (typeof obj === 'boolean') {
        newObj = { visible: obj, required: false }
      } else {
        newObj = { ...obj }
      }

      // Toggle la propriété
      newObj[prop] = !newObj[prop]

      // Règle métier : si visible = false, required = false
      if (prop === 'visible' && !newObj.visible) {
        newObj.required = false
      }

      const newForm = set(this.currentFormSettings, this.path, newObj)
      this.mutateFormConfig(newForm)
    }
  }
}
</script>
